import React from "react";
import { ButtonGroup, Button, Box, Typography } from "@mui/material";
import { translations } from "translations";
import Props from "./index.d";

const UnitFormModeToggle: React.FC<Props> = (props) => {
  const {
    className,
    data: { state, setAndSave },
  } = props;

  const currentMode = (state as string) || "unit";

  const handleModeChange = (mode: string) => {
    setAndSave(mode);
  };

  return (
    <Box className={className} sx={{ mb: 3, backgroundColor: "white", px: 4, py: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {translations.pages.certificationManagement.parameterView}
      </Typography>
      <ButtonGroup
        variant="contained"
        size="large"
        sx={{
          width: "100%",
          "& .MuiButton-root": {
            flex: 1,
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 0,
          },
        }}
      >
        <Button
          onClick={() => handleModeChange("unit")}
          variant={currentMode === "unit" ? "contained" : "outlined"}
          color={currentMode === "unit" ? "primary" : "inherit"}
          sx={{
            backgroundColor: currentMode === "unit" ? "primary.main" : "white",
            color: currentMode === "unit" ? "white" : "text.primary",
            "&:hover": {
              backgroundColor: currentMode === "unit" ? "primary.dark" : "action.hover",
            },
          }}
        >
          {translations.pages.accessPermissionManagement.gridConnectionValues}
        </Button>
        <Button
          onClick={() => handleModeChange("grid")}
          variant={currentMode === "grid" ? "contained" : "outlined"}
          color={currentMode === "grid" ? "primary" : "inherit"}
          sx={{
            backgroundColor: currentMode === "grid" ? "primary.main" : "white",
            color: currentMode === "grid" ? "white" : "text.primary",
            "&:hover": {
              backgroundColor: currentMode === "grid" ? "primary.dark" : "action.hover",
            },
          }}
        >
          {translations.pages.certificationManagement.instantaneousReserve}
        </Button>
      </ButtonGroup>
    </Box>
  );
};

export default UnitFormModeToggle;
